module.exports = __webpack_public_path__ + "assets/sound-effects-9064fd13.mp3";